import Vue from "vue";
import App from "./App.vue";

import "./assets/scss/main.scss";

import VueRouter from "vue-router";
import VueLazyload from 'vue-lazyload'
import router from "./router";
import VueContentPlaceholders from "vue-content-placeholders";



Vue.use(VueLazyload, {
  preLoad: 1.3,
  loading: 'https://uptodatewebdesign.s3.eu-west-3.amazonaws.com/static/assets/loader.gif',
  attempt: 1
})

let app = document.getElementById("app");
let props = {
  page: app.getAttribute("data-page"),
  filters: app.getAttribute("data-filters").toLowerCase(),
};

Vue.use(VueContentPlaceholders);
Vue.use(VueRouter);

Vue.config.productionTip = false;
Vue.prototype.shopSettings = props;

new Vue({
  render: (h) => h(App),
  router,
}).$mount("#app");
